import Vue from 'vue'
import Router from 'vue-router'
/* Layout */
import Layout from '../views/layout/Layout'

Vue.use(Router)

/**
 * hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
 *                                if not set alwaysShow, only more than one route under the children
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
  }
 **/
export const constantRouterMap = [{
  path: '/login',
  component: () => import('@/views/login/index'),
  hidden: true
}, {path: '/404', component: () => import('@/views/404'), hidden: true}, {
  path: '', component: Layout, redirect: '/home', children: [{
    path: 'home', name: 'home', component: () => import('@/views/home/index'), meta: {title: '首页', icon: 'home'}
  }]
}]

export const asyncRouterMap = [{
  path: '/android',
  component: Layout,
  redirect: '/android/androidFeature',
  name: 'android',
  meta: {title: 'android', icon: 'android'},
  children: [ /*{
    path: 'androidModelVersion',
    name: 'androidModelVersion',
    component: () => import('@/views/android/modelVersion/index'),
    meta: {title: 'android加固版本', icon: 'modelVerion'}
  }, {
    path: 'androidAddModelVersion',
    name: 'androidAddModelVersion',
    component: () => import('@/views/android/modelVersion/add'),
    meta: {title: '添加android加固版本'},
    hidden: true
  }, {
    path: 'androidUpdateModelVersion',
    name: 'androidUpdateModelVersion',
    component: () => import('@/views/android/modelVersion/update'),
    meta: {title: '修改android加固版本'},
    hidden: true
  }, {
    path: 'androidAddSoild',
    name: 'androidAddSoild',
    component: () => import('@/views/android/addSoild/index'),
    meta: {title: 'android加固记录', icon: 'addSoild'}
  }, {
    path: 'androidHistoryAddSoild',
    name: 'androidHistoryAddSoild',
    component: () => import('@/views/android/addSoild/history'),
    meta: {title: '查看android加固记录'},
    hidden: true
  }, {
    path: 'androidLocalFeature',
    name: 'androidLocalFeature',
    component: () => import('@/views/android/localFeature/index'),
    meta: {title: 'android本地特征', icon: 'localFeature'}
  }, {
    path: 'androidAddLocalFeature',
    name: 'androidAddLocalFeature',
    component: () => import('@/views/android/localFeature/add'),
    meta: {title: '添加android本地特征'},
    hidden: true
  }, {
    path: 'androidUpdateLocalFeature',
    name: 'androidUpdateLocalFeature',
    component: () => import('@/views/android/localFeature/update'),
    meta: {title: '修改android本地特征'},
    hidden: true
  }, */{
    path: 'androidFeature',
    name: 'androidFeature',
    component: () => import('@/views/android/feature/index'),
    meta: {title: 'android特征维护', icon: 'feature'}
  }, {
    path: 'androidAddFeature',
    name: 'androidAddFeature',
    component: () => import('@/views/android/feature/add'),
    meta: {title: '添加android常规特征'},
    hidden: true
  }, {
    path: 'androidUpdateFeature',
    name: 'androidUpdateFeature',
    component: () => import('@/views/android/feature/update'),
    meta: {title: '修改android常规特征'},
    hidden: true
  }, {
    path: 'androidPlugIn',
    name: 'androidPlugIn',
    component: () => import('@/views/android/plugIn/index'),
    meta: {title: 'android特征发布', icon: 'plugIn'}
  }, {
    path: 'androidFeatureTask',
    name: 'androidFeatureTask',
    component: () => import('@/views/android/featureTask/index'),
    meta: {title: 'android特征更新任务', icon: 'featureTask'}
  }, {
    path: 'androidAddFeatureTask',
    name: 'androidAddFeatureTask',
    component: () => import('@/views/android/featureTask/add'),
    meta: {title: '添加android特征更新任务', icon: 'featureTask'},
    hidden: true
  }, {
    path: 'androidHistoryFeatureTask',
    name: 'androidHistoryFeatureTask',
    component: () => import('@/views/android/featureTask/history'),
    meta: {title: '查看android特征更新任务', icon: 'featureTask'},
    hidden: true
  }, {
    path: 'androidFlagTask',
    name: 'androidFlagTask',
    component: () => import('@/views/android/flagTask/index'),
    meta: {title: 'android flag任务', icon: 'flagTask'}
  }, {
    path: 'androidAddFlagTask',
    name: 'androidAddFlagTask',
    component: () => import('@/views/android/flagTask/add'),
    meta: {title: '添加android flag任务', icon: 'flagTask'},
    hidden: true
  }, {
    path: 'androidHistoryFlagTask',
    name: 'androidHistoryFlagTask',
    component: () => import('@/views/android/flagTask/history'),
    meta: {title: '查看android flag任务', icon: 'flagTask'},
    hidden: true
  }, /*{
    path: 'androidThreatData',
    name: 'androidThreatData',
    component: () => import('@/views/android/threatData/index'),
    meta: {title: 'android风险数据', icon: 'threatData'}
  }, {
    path: 'androidRiskTrend',
    name: 'androidRiskTrend',
    component: () => import('@/views/android/threatData/riskTrend'),
    meta: {title: 'android风险趋势', icon: 'riskTrend'}
  },*/ {
    path: 'androidPunishment',
    name: 'androidPunishment',
    component: () => import('@/views/android/punishment/index'),
    meta: {title: 'android处罚系统', icon: 'punishment'}
  }, {
    path: 'androidAddPunishment',
    name: 'androidAddPunishment',
    component: () => import('@/views/android/punishment/add'),
    meta: {title: '添加android处罚规则', icon: 'punishment'},
    hidden: true
  }, {
    path: 'androidPunishmentDetail',
    name: 'androidPunishmentDetail',
    component: () => import('@/views/android/punishment/detail'),
    meta: {title: '查看android处罚规则', icon: 'punishment'},
    hidden: true
  },{
    path: 'androidPunishmentEdit',
    name: 'androidPunishmentEdit',
    component: () => import('@/views/android/punishment/edit'),
    meta: {title: '编辑android处罚规则', icon: 'punishment'},
    hidden: true
  },{
    path: 'androidPunishmentAccountList',
    name: 'androidPunishmentAccountList',
    component: () => import('@/views/android/punishment/account/list'),
    meta: {title: 'android处罚账户列表', icon: 'punishment'},
    hidden: true
  },{
    path: 'androidPunishmentAccountTestList',
    name: 'androidPunishmentAccountTestList',
    component: () => import('@/views/android/punishment/account/testList'),
    meta: {title: 'android处罚测试账户列表', icon: 'punishment'},
    hidden: true
  },{
    path: 'androidPunishmentChart',
    name: 'androidPunishmentChart',
    component: () => import('@/views/android/punishment/chart'),
    meta: {title: 'android处罚账户图表', icon: 'punishment'},
    hidden: true
  },{
    path: 'androidMiningStrategy',
    name: 'androidMiningStrategy',
    component: () => import('@/views/android/mining/index'),
    meta: {title: 'android数据挖掘策略', icon: 'mining'},
    },
    {
      path: 'androidAddMiningStrategy',
      name: 'androidAddMiningStrategy',
      component: () => import('@/views/android/mining/add'),
      meta: { title: '添加策略', icon: 'mining' },
      hidden: true
    },{
      path: 'androidUpdateMiningStrategy',
      name: 'androidUpdateMiningStrategy',
      component: () => import('@/views/android/mining/update'),
      meta: { title: '编辑策略', icon: 'mining' },
      hidden: true
    },
    {
      path: 'androidInfoMiningStrategy',
      name: 'androidInfoMiningStrategy',
      component: () => import('@/views/android/mining/info'),
      meta: { title: '策略详情', icon: 'mining' },
      hidden: true
    },
  ]
}, {
  path: '/ios',
  component: Layout,
  redirect: '/ios/iosFeature',
  name: 'ios',
  meta: {title: 'ios', icon: 'ios'},
  children: [ /*{
    path: 'iosModelVersion',
    name: 'iosModelVersion',
    component: () => import('@/views/ios/modelVersion/index'),
    meta: {title: 'ios加固版本', icon: 'modelVerion'}
  }, {
    path: 'iosAddModelVersion',
    name: 'iosAddModelVersion',
    component: () => import('@/views/ios/modelVersion/add'),
    meta: {title: '添加ios加固版本'},
    hidden: true
  }, {
    path: 'iosUpdateModelVersion',
    name: 'iosUpdateModelVersion',
    component: () => import('@/views/ios/modelVersion/update'),
    meta: {title: '修改ios加固版本'},
    hidden: true
  }, {
    path: 'iosToolVersion',
    name: 'iosToolVersion',
    component: () => import('@/views/ios/toolVersion/index'),
    meta: {title: 'ios工具版本', icon: 'toolVerion'}
  }, {
    path: 'iosAddToolVersion',
    name: 'iosAddToolVersion',
    component: () => import('@/views/ios/toolVersion/add'),
    meta: {title: '添加ios工具版本'},
    hidden: true
  }, {
    path: 'iosUpdateToolVersion',
    name: 'iosUpdateToolVersion',
    component: () => import('@/views/ios/toolVersion/update'),
    meta: {title: '修改ios工具版本'},
    hidden: true
  }, {
    path: 'iosAddSoild',
    name: 'iosAddSoild',
    component: () => import('@/views/ios/addSoild/index'),
    meta: {title: 'ios加固记录', icon: 'addSoild'}
  }, {
    path: 'iosHistoryAddSoild',
    name: 'iosHistoryAddSoild',
    component: () => import('@/views/ios/addSoild/history'),
    meta: {title: '查看ios加固记录'},
    hidden: true
  }, {
    path: 'iosLocalFeature',
    name: 'iosLocalFeature',
    component: () => import('@/views/ios/localFeature/index'),
    meta: {title: 'ios本地特征', icon: 'localFeature'}
  }, {
    path: 'iosAddLocalFeature',
    name: 'iosAddLocalFeature',
    component: () => import('@/views/ios/localFeature/add'),
    meta: {title: '添加ios本地特征'},
    hidden: true
  }, {
    path: 'iosUpdateLocalFeature',
    name: 'iosUpdateLocalFeature',
    component: () => import('@/views/ios/localFeature/update'),
    meta: {title: '修改ios本地特征'},
    hidden: true
  },*/ {
    path: 'iosFeature',
    name: 'iosFeature',
    component: () => import('@/views/ios/feature/index'),
    meta: {title: 'ios特征维护', icon: 'feature'}
  }, {
    path: 'iosAddFeature',
    name: 'iosAddFeature',
    component: () => import('@/views/ios/feature/add'),
    meta: {title: '添加ios常规特征'},
    hidden: true
  }, {
    path: 'iosUpdateFeature',
    name: 'iosUpdateFeature',
    component: () => import('@/views/ios/feature/update'),
    meta: {title: '修改ios常规特征'},
    hidden: true
  }, {
    path: 'iosPlugIn',
    name: 'iosPlugIn',
    component: () => import('@/views/ios/plugIn/index'),
    meta: {title: 'ios特征发布', icon: 'plugIn'}
  }, {
    path: 'iosFeatureTask',
    name: 'iosFeatureTask',
    component: () => import('@/views/ios/featureTask/index'),
    meta: {title: 'ios特征更新任务', icon: 'featureTask'}
  }, {
    path: 'iosAddFeatureTask',
    name: 'iosAddFeatureTask',
    component: () => import('@/views/ios/featureTask/add'),
    meta: {title: '添加ios特征更新任务', icon: 'featureTask'},
    hidden: true
  }, {
    path: 'iosHistoryFeatureTask',
    name: 'iosHistoryFeatureTask',
    component: () => import('@/views/ios/featureTask/history'),
    meta: {title: '查看ios特征更新任务', icon: 'featureTask'},
    hidden: true
  }, {
    path: 'iosFlagTask',
    name: 'iosFlagTask',
    component: () => import('@/views/ios/flagTask/index'),
    meta: {title: 'ios Flag任务', icon: 'flagTask'}
  }, {
    path: 'iosAddFlagTask',
    name: 'iosAddFlagTask',
    component: () => import('@/views/ios/flagTask/add'),
    meta: {title: '添加ios Flag任务', icon: 'flagTask'},
    hidden: true
  }, {
    path: 'iosHistoryFlagTask',
    name: 'iosHistoryFlagTask',
    component: () => import('@/views/ios/flagTask/history'),
    meta: {title: '查看ios Flag任务', icon: 'flagTask'},
    hidden: true
  }, /*{
    path: 'iosThreatData',
    name: 'iosThreatData',
    component: () => import('@/views/ios/threatData/index'),
    meta: {title: 'ios风险数据', icon: 'threatData'}
  }, {
    path: 'iosRiskTrend',
    name: 'iosRiskTrend',
    component: () => import('@/views/ios/threatData/riskTrend'),
    meta: {title: 'ios风险趋势', icon: 'riskTrend'}
  }*/ {
    path: 'iosPunishment',
    name: 'iosPunishment',
    component: () => import('@/views/ios/punishment/index'),
    meta: {title: 'ios处罚系统', icon: 'punishment'}
  }, {
    path: 'iosAddPunishment',
    name: 'iosAddPunishment',
    component: () => import('@/views/ios/punishment/add'),
    meta: {title: '添加ios处罚规则', icon: 'punishment'},
    hidden: true
  }, {
    path: 'iosPunishmentDetail',
    name: 'iosPunishmentDetail',
    component: () => import('@/views/ios/punishment/detail'),
    meta: {title: '查看ios处罚规则', icon: 'punishment'},
    hidden: true
  },{
    path: 'iosPunishmentEdit',
    name: 'iosPunishmentEdit',
    component: () => import('@/views/ios/punishment/edit'),
    meta: {title: '编辑ios处罚规则', icon: 'punishment'},
    hidden: true
  },{
    path: 'iosPunishmentAccountList',
    name: 'iosPunishmentAccountList',
    component: () => import('@/views/ios/punishment/account/list'),
    meta: {title: 'ios处罚账户列表', icon: 'punishment'},
    hidden: true
  },{
    path: 'iosPunishmentAccountTestList',
    name: 'iosPunishmentAccountTestList',
    component: () => import('@/views/ios/punishment/account/testList'),
    meta: {title: 'ios处罚测试账户列表', icon: 'punishment'},
    hidden: true
  },{
    path: 'iosPunishmentChart',
    name: 'iosPunishmentChart',
    component: () => import('@/views/ios/punishment/chart'),
    meta: {title: 'ios处罚账户图表', icon: 'punishment'},
    hidden: true
    },{
      path: 'iosMiningStrategy',
      name: 'iosMiningStrategy',
      component: () => import('@/views/ios/mining/index'),
      meta: {title: 'ios数据挖掘策略', icon: 'mining'},
      },
      {
        path: 'iosAddMiningStrategy',
        name: 'iosAddMiningStrategy',
        component: () => import('@/views/ios/mining/add'),
        meta: { title: 'ios添加策略', icon: 'mining' },
        hidden: true
      },{
        path: 'iosUpdateMiningStrategy',
        name: 'iosUpdateMiningStrategy',
        component: () => import('@/views/ios/mining/update'),
        meta: { title: 'ios编辑策略', icon: 'mining' },
        hidden: true
      },
      {
        path: 'iosInfoMiningStrategy',
        name: 'iosInfoMiningStrategy',
        component: () => import('@/views/ios/mining/info'),
        meta: { title: 'ios策略详情', icon: 'mining' },
        hidden: true
      },
  ]
  }, {
    path: '/reportMonitor',
    component: Layout,
    redirect: '/reportMonitor/freefire',
    name: 'reportMonitor',
    meta: { title: '举报监控', icon: 'monitor' },
    children: [ {
      path: 'freefire',
      name: 'freefire',
      component: () => import('@/views/report/ff/monitor/index'),
      meta: {title: 'freefire举报监控', icon: 'chart'}
    },
    {
      path: 'ffReportAccountList',
      name: 'ffReportAccountList',
      component: () => import('@/views/report/ff/monitor/reportList'),
      meta: { title: 'freefire举报名单', icon: 'chart' },
      hidden:true
      },
      {
        path: 'ffReportMonitorRuleList',
        name: 'ffReportMonitorRuleList',
        component: () => import('@/views/report/ff/monitor/ruleList'),
        meta: { title: 'freefire举报监控规则', icon: 'chart' },
        hidden:true
      },
      {
        path: 'ffReportMonitorRuleAdd',
        name: 'ffReportMonitorRuleAdd',
        component: () => import('@/views/report/ff/monitor/ruleAdd'),
        meta: { title: '新建freefire举报监控规则', icon: 'chart' },
        hidden:true
      },
      {
        path: 'ffReportMonitorRuleDetail',
        name: 'ffReportMonitorRuleDetail',
        component: () => import('@/views/report/ff/monitor/ruleDetail'),
        meta: { title: 'freefire举报监控规则详情', icon: 'chart' },
        hidden:true
      },
      {
        path: 'ffReportMonitorRuleEdit',
        name: 'ffReportMonitorRuleEdit',
        component: () => import('@/views/report/ff/monitor/ruleEdit'),
        meta: { title: 'freefire举报监控规则编辑', icon: 'chart' },
        hidden:true
      },{
        path: 'ffReportMonitorUnBannedList',
        name: 'ffReportMonitorUnBannedList',
        component: () => import('@/views/report/ff/monitor/unBannedPage'),
        meta: { title: 'freefire举报监控未封禁列表', icon: 'chart' },
        hidden:true
      },
    {
      path: 'sigma',
      name: 'sigma',
      component: () => import('@/views/report/sigma/monitor/index'),
      meta: {title: 'sigmax举报监控', icon: 'chart'}
      },
      {
        path: 'sigmaReportAccountList',
        name: 'sigmaReportAccountList',
        component: () => import('@/views/report/sigma/monitor/reportList'),
        meta: { title: 'sigma举报名单', icon: 'chart' },
        hidden:true
        },
        {
          path: 'sigmaReportMonitorRuleList',
          name: 'sigmaReportMonitorRuleList',
          component: () => import('@/views/report/sigma/monitor/ruleList'),
          meta: { title: 'sigma举报监控规则', icon: 'chart' },
          hidden:true
        },
        {
          path: 'sigmaReportMonitorRuleAdd',
          name: 'sigmaReportMonitorRuleAdd',
          component: () => import('@/views/report/sigma/monitor/ruleAdd'),
          meta: { title: '新建sigma举报监控规则', icon: 'chart' },
          hidden:true
        },
        {
          path: 'sigmaReportMonitorRuleDetail',
          name: 'sigmaReportMonitorRuleDetail',
          component: () => import('@/views/report/sigma/monitor/ruleDetail'),
          meta: { title: 'sigma举报监控规则详情', icon: 'chart' },
          hidden:true
        },
        {
          path: 'sigmaReportMonitorRuleEdit',
          name: 'sigmaReportMonitorRuleEdit',
          component: () => import('@/views/report/sigma/monitor/ruleEdit'),
          meta: { title: 'sigma举报监控规则编辑', icon: 'chart' },
          hidden:true
        },{
          path: 'sigmaReportMonitorUnBannedList',
          name: 'sigmaReportMonitorUnBannedList',
          component: () => import('@/views/report/sigma/monitor/unBannedPage'),
          meta: { title: 'sigma举报监控未封禁列表', icon: 'chart' },
          hidden:true
        },
    ]
  },
  {
  path: '/ums', component: Layout, redirect: '/ums/admin', name: 'ums', meta: {title: '权限', icon: 'ums'}, children: [{
    path: 'admin',
    name: 'admin',
    component: () => import('@/views/ums/admin/index'),
    meta: {title: '用户列表', icon: 'ums-admin'}
  }, {
    path: 'role',
    name: 'role',
    component: () => import('@/views/ums/role/index'),
    meta: {title: '角色列表', icon: 'ums-role'}
  }, {
    path: 'allocMenu',
    name: 'allocMenu',
    component: () => import('@/views/ums/role/allocMenu'),
    meta: {title: '分配菜单'},
    hidden: true
  }, {
    path: 'allocResource',
    name: 'allocResource',
    component: () => import('@/views/ums/role/allocResource'),
    meta: {title: '分配资源'},
    hidden: true
  }, {
    path: 'menu',
    name: 'menu',
    component: () => import('@/views/ums/menu/index'),
    meta: {title: '菜单列表', icon: 'ums-menu'}
  }, {
    path: 'addMenu',
    name: 'addMenu',
    component: () => import('@/views/ums/menu/add'),
    meta: {title: '添加菜单'},
    hidden: true
  }, {
    path: 'updateMenu',
    name: 'updateMenu',
    component: () => import('@/views/ums/menu/update'),
    meta: {title: '修改菜单'},
    hidden: true
  }, {
    path: 'resource',
    name: 'resource',
    component: () => import('@/views/ums/resource/index'),
    meta: {title: '资源列表', icon: 'ums-resource'}
  }, {
    path: 'resourceCategory',
    name: 'resourceCategory',
    component: () => import('@/views/ums/resource/categoryList'),
    meta: {title: '资源分类'},
    hidden: true
  },{
    path: 'androidGameKey',
    name: 'androidGameKey',
    component: () => import('@/views/ums/androidGameKey/index'),
    meta: {title: 'androidGameKey', icon: 'gameKey'}
  }, {
    path: 'androidAddGameKey',
    name: 'androidAddGameKey',
    component: () => import('@/views/ums/androidGameKey/add'),
    meta: {title: '添加androidGameKey'},
    hidden: true
  }, {
    path: 'androidUpdateGameKey',
    name: 'androidUpdateGameKey',
    component: () => import('@/views/ums/androidGameKey/update'),
    meta: {title: '修改androidGameKey'},
    hidden: true
  }, {
    path: 'androidHistoryGameKey',
    name: 'androidHistoryGameKey',
    component: () => import('@/views/ums/androidGameKey/history'),
    meta: {title: '查看androidGameKey'},
    hidden: true
  }, {
    path: 'iosGameKey',
    name: 'iosGameKey',
    component: () => import('@/views/ums/iosGameKey/index'),
    meta: {title: 'iosGameKey', icon: 'gameKey'}
  }, {
    path: 'iosAddGameKey',
    name: 'iosAddGameKey',
    component: () => import('@/views/ums/iosGameKey/add'),
    meta: {title: '添加iosGameKey'},
    hidden: true
  }, {
    path: 'iosUpdateGameKey',
    name: 'iosUpdateGameKey',
    component: () => import('@/views/ums/iosGameKey/update'),
    meta: {title: '修改iosGameKey'},
    hidden: true
  }, {
    path: 'iosHistoryGameKey',
    name: 'iosHistoryGameKey',
    component: () => import('@/views/ums/iosGameKey/history'),
    meta: {title: '查看iosGameKey'},
    hidden: true
  }/*,{
    path: 'actionLog',
    name: 'actionLog',
    component: () => import('@/views/ums/actionLog/index'),
    meta: {title: '操作日志', icon: 'actionLog'}
  }*/]
  }, { path: '*', redirect: '/404', hidden: true }]

export default new Router({
  // mode: 'history', //后端支持可开
  scrollBehavior: () => ({y: 0}), routes: constantRouterMap
})




// WEBPACK FOOTER //
// ./src/router/index.js